import queryString from 'query-string';


export default function fixQueryString(url, newParams) {
  // add or replace specific query params in an url with new values
  const [baseUrl, oldParamsString] = url.split('?', 2);
  const oldParams = queryString.parse(oldParamsString);
  const finalParamsString = queryString.stringify({ ...oldParams, ...newParams }, { encode: false });
  return `${baseUrl}?${finalParamsString}`;
};
